import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Calendar, CheckCircle, Coffee, Brain, TrendingUp, Heart, Building2, Gift, Phone, Monitor } from 'lucide-react';
import ServicesModal from '../ServicesModal/ServicesModal';
import './NutricionEmpresarial.css';

const NutricionEmpresarial = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const servicios = [
    {
      title: "Alimentación Saludable en el Trabajo",
      icon: Coffee,
      topics: [
        "Organización de comidas semanales",
        "Snacks saludables",
        "Hidratación laboral"
      ]
    },
    {
      title: "Manejo del Estrés y Alimentación Consciente",
      icon: Brain,
      topics: [
        "Control de antojos",
        "Relación saludable con la comida"
      ]
    },
    {
      title: "Programas de Bienestar Corporativo",
      icon: TrendingUp,
      topics: [
        "Charlas periódicas",
        "Campañas internas de salud",
        "Retos saludables"
      ]
    },
    {
      title: "Promoción de la Salud Ocupacional",
      icon: Heart,
      topics: [
        "Actividades nutricionales para RRHH y SST",
        "Educación preventiva para trabajadores"
      ]
    }
  ];

  const beneficios = [
    "Mejora del rendimiento y productividad laboral",
    "Reducción del ausentismo por enfermedades",
    "Mayor satisfacción y bienestar del equipo",
    "Fortalecimiento de la cultura organizacional",
    "Programas adaptados a cada empresa"
  ];

  return (
    <div className="empresarial-container">
      <div className="empresarial-content">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="empresarial-header"
        >
          <h2 className="empresarial-main-title">
            <span className="empresarial-title-emoji">💼</span>{' '}
            <span className="empresarial-title-dark">Nutrición</span>{' '}
            <span className="empresarial-title-yellow">Empresarial</span>
          </h2>
          <p className="empresarial-subtitle">
            Enfocadas en bienestar laboral y productividad.
          </p>
        </motion.div>

        <div className="empresarial-grid">
          {servicios.map((servicio, index) => {
            const IconComponent = servicio.icon;
            const emojis = ['💼', '🧘', '📈', '🏥'];
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.1 * index }}
                whileHover={{ scale: 1.03 }}
                className="empresarial-card"
              >
                <div className="empresarial-icon-wrapper">
                  <span className="empresarial-emoji">{emojis[index]}</span>
                  <IconComponent className="empresarial-icon" />
                </div>
                
                <h3 className="empresarial-card-title">{servicio.title}</h3>

                <div className="empresarial-topics">
                  <ul className="empresarial-topics-list">
                    {servicio.topics.map((topic, idx) => (
                      <li key={idx} className="empresarial-topic-item">
                        <CheckCircle className="empresarial-check-icon" />
                        <span>{topic}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </motion.div>
            );
          })}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="empresarial-modalidad-section"
        >
          <div className="empresarial-modalidad-content">
            <div className="empresarial-modalidad-item">
              <Monitor className="empresarial-modalidad-icon" />
              <div>
                <strong>Modalidad:</strong> Presencial o Virtual
              </div>
            </div>
            <div className="empresarial-modalidad-item">
              <Calendar className="empresarial-modalidad-icon" />
              <div>
                <strong>Formato:</strong> Charla única o programas mensuales
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="empresarial-beneficios-section"
        >
          <h3 className="empresarial-beneficios-title">
            <Gift className="empresarial-beneficios-icon-title" />
            ¿Por qué invertir en nutrición empresarial?
          </h3>
          <div className="empresarial-beneficios-grid">
            {beneficios.map((beneficio, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.6 + (0.1 * index) }}
                className="empresarial-beneficio-item"
              >
                <CheckCircle className="empresarial-beneficio-icon" />
                <span>{beneficio}</span>
              </motion.div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.7 }}
          className="empresarial-cta-section"
        >
          <Building2 className="empresarial-cta-icon" />
          <h3 className="empresarial-cta-title">¿Listo para impulsar el bienestar en tu empresa?</h3>
          <p className="empresarial-cta-description">
            Diseñamos programas nutricionales personalizados según las necesidades de tu organización.
          </p>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="empresarial-cta-button"
            onClick={handleOpenModal}
          >
            <Phone className="empresarial-button-icon" />
            Solicita una propuesta
          </motion.button>
        </motion.div>
      </div>

      {/* Services Modal */}
      {isModalOpen && (
        <ServicesModal 
          isOpen={isModalOpen} 
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
};

export default NutricionEmpresarial;